const actionTypes = {
    SHOW_ERROR: 'AFTERPAY_SHOW_ERROR',
    RESET_ERROR: 'AFTERPAY_RESET_ERROR',
    TOGGLE_SELECTED: 'AFTERPAY_TOGGLE_SELECTED',
    SET_READY: 'AFTERPAY_SET_READY'
};

module.exports = actionTypes;
